import { render, staticRenderFns } from "./WithdrawalConfirmDeclineDialog.vue?vue&type=template&id=60ba3f20&scoped=true"
import script from "./WithdrawalConfirmDeclineDialog.vue?vue&type=script&lang=js"
export * from "./WithdrawalConfirmDeclineDialog.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalConfirmDeclineDialog.vue?vue&type=style&index=0&id=60ba3f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba3f20",
  null
  
)

export default component.exports